import { BannerRequestImpl } from '../../../../core/api/banner/getbanner/bannerrequest';
import { BannerResponse } from '../../../../core/api/banner/getbanner/bannerresponse';
import { CategoriesRequestImpl } from '../../../../core/api/categories/categoriesrequest';
import { CategoriesResponse } from '../../../../core/api/categories/categoriesresponse';
import { BannerDtoImpl } from '../../../../core/dto/banner/bannerdto';
//import { GetMusicBoxContentsRequestImpl } from '../../../../core/api/wishlist/getmusicboxcontents/getmusicboxcontentsrequest';
//import { GetMusicBoxContentsResponse } from '../../../../core/api/wishlist/getmusicboxcontents/getmusicboxcontentsresponse';
//import { GetMusicBoxContentsDtoImpl } from '../../../../core/dto/musicboxcontents/getmusicboxcontentsdto';
import { CategoryDtoImpl } from '../../../../core/dto/categories/categorydto';
//import { GetKaroakeListDtoImpl } from '../../../../core/dto/getkaroakelist/getkaroakelistdto';
//import { GetKaroakeListRequestImpl } from '../../../../core/api/karoake/getkaroakelist/getkaroakelistrequest';
//import { GetKaroakeListResponse } from '../../../../core/api/karoake/getkaroakelist/getkaroakelistresponse';
import { APIModel, APIModelHandler, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { SubscriptionPlanDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { SubscriptionPlanDetailsResponse } from 'src/com/sixdee/crbtportal/core/api/subscriptionplandetails/subscriptionplandetailsresponse';
import { SubscriptionPlandetailsRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscriptionplandetails/subscriptionplandetailsrequest';
import { SettingsResponse } from 'src/com/sixdee/crbtportal/core/api/settings/settingsresponse';
import { SettingsRequestImpl } from 'src/com/sixdee/crbtportal/core/api/settings/settingsrequest';
import { PasswordValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/passwordvalidation/passwordvalidationrequest';
import { PasswordValidationResponse } from 'src/com/sixdee/crbtportal/core/api/passwordvalidation/passwordvalidationresponse';
import { SecurityTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenrequest';
import { SecurityTokenResponse } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenresponse';
import { LoginDto } from 'src/com/sixdee/crbtportal/core/dto/login/logindto';
import { PasswordValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/passwordvalidation/passwordvalidationdto';
import { SecurityTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/securitytoken/securitytokendto';
import { RsaService } from 'src/com/sixdee/crbtportal/utils/rsaservice';
import { LoginProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/loginprocessorfactory';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { CreateAccountRequestImpl } from 'src/com/sixdee/crbtportal/core/api/createaccount/createaccountrequest';
import { CreateAccountResponse } from 'src/com/sixdee/crbtportal/core/api/createaccount/createaccountresponse';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { CreateAccountDto, CreateAccountDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';

export interface HomeAPIModel extends APIModel
{
  getSettings(): void;
  getCategories(): void;
  getBanners(): void; 
  getSubscriptionPlanDetails():void;
  doLogin(loginDto: LoginDto): void;
  createAccount(createAccountDto: CreateAccountDto, securityToken: string): void;
  getSecurityCounter(): void;
  validateSubscriber(loginDto: LoginDto): void;
}

export class HomeAPIModelImpl extends APIModelImpl implements HomeAPIModel
{
  private loginProcessorFactory: LoginProcessorFactory;

    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }
  
   getSettings(): void 
   {    
    this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().getSettings()
        .success((settingsResponse: SettingsResponse) => {
          this.getAPIModelHandler().onSuccess(settingsResponse.getAPIFeature(), 
          settingsResponse.getDescription(), settingsResponse); 
        })
        .failure((settingsResponse: SettingsResponse) => {
          this.getAPIModelHandler().onFailure(settingsResponse.getAPIFeature(), 
          settingsResponse.getDescription(), settingsResponse);
        })
        .execute(new SettingsRequestImpl());
      }

    getCategories(): void 
    {
        let categoryDto = new CategoryDtoImpl();
        categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
        this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory().getCategories()
                   .success((categoriesResponse : CategoriesResponse)=>
                    {
                        this.getAPIModelHandler().onSuccess(categoriesResponse.getAPIFeature(), 
                        categoriesResponse.getDescription(), []); 
                    })
                  .failure((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(categoriesResponse.getAPIFeature(), 
                      categoriesResponse.getDescription(), categoriesResponse);
                    })
                  .execute(new CategoriesRequestImpl(categoryDto));
    }

    getBanners(): void 
    {
        let bannerDto = new BannerDtoImpl();
        bannerDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getBannerAPIProcessorFactory().getBanners()
                .success((bannerResponse: BannerResponse)=>
                {
                   this.getAPIModelHandler().onSuccess(bannerResponse.getAPIFeature(), 
                   bannerResponse.getDescription(), bannerResponse.getListOfBannerDtos());
                })
                .failure((bannerResponse: BannerResponse)=>
                {
                    this.getAPIModelHandler().onFailure(bannerResponse.getAPIFeature(), 
                    bannerResponse.getDescription(), undefined);
                })
                .execute(new BannerRequestImpl(bannerDto));
    }
   
    //clientTxnId=1472323340&language=English&aPartyMsisdn=0504843969&channelId=9&memberDetailList=[{"bPartyMsisdn":"0986745231"}]
    getSubscriptionPlanDetails():void
    {
      console.log("getSubscriptionPlanDetails() invoked $$$$$$$$");
      let subscriptionDto = new SubscriptionPlanDetailsDtoImpl();
      // subscriptionDto.setTitle("Express your mood with the back tone sent with");
      // subscriptionDto.setDescriptionList(this.getDescriptionList());
      this.getAPIProcesssorFactory().getSubscriptionPlanDetailsProcessorFactory()
        .getSubscriptionPlanDetails()
        .success((subscriptionResponse: SubscriptionPlanDetailsResponse)=>
        {
            console.log("success() invoked ##########SUBSCRIPTION PLAN###############");

            this.getAPIModelHandler().onSuccess(subscriptionResponse.getAPIFeature(), 
            subscriptionResponse.getDescription(), subscriptionResponse.getSubscriptionPlanDetailsDtos());
         })
        .failure((subscriptionResponse: SubscriptionPlanDetailsResponse)=>
         {
           this.getAPIModelHandler().onFailure(subscriptionResponse.getAPIFeature(), 
           subscriptionResponse.getDescription(), undefined);
         })
        .execute(new SubscriptionPlandetailsRequestImpl(subscriptionDto));
    }

    validateSubscriber(loginDto: LoginDto): void {
      let subscriberValidationDto = new SubscriberValidationDtoImpl();
      subscriberValidationDto.setMsisdn(loginDto.getMsisdn());
      subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

      this.loginProcessorFactory.validateSubscriber()
          .success((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                  subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
  }

  createAccount(createAccountDto: CreateAccountDto, securityToken: string)
    {
        let encryptedPassword = RsaService.getInstance(this.getContext().getProperty()).encryptWithNodeRSA(createAccountDto.getPassword() + securityToken
        );

        (createAccountDto as CreateAccountDtoImpl).setSecurityCounter(securityToken);
        (createAccountDto as CreateAccountDtoImpl).setIsOtpRequired(false);
        (createAccountDto as CreateAccountDtoImpl).setUserName(createAccountDto.getMsisdn());
        (createAccountDto as CreateAccountDtoImpl).setEncryptedPassword(encryptedPassword);
        this.loginProcessorFactory.createAccount()
        .success((createAccountResponse : CreateAccountResponse)=>
        {
            // this.getContext().getUserContext().setMsisdnB(createAccountDto.getMsisdn());
            // this.getContext().getUserContext().setSecToken(createAccountResponse.getCreateAccountDetails().getSecToc());
              
            // this.getContext().setUserContext(this.getContext().getUserContext());
            this.getAPIModelHandler().onSuccess(createAccountResponse.getAPIFeature(), 
            createAccountResponse.getDescription(), createAccountResponse.getCreateAccountDetails());
        })
        .failure((createAccountResponse : CreateAccountResponse)=>
        {
            this.getAPIModelHandler().onFailure(createAccountResponse.getAPIFeature(), 
            createAccountResponse.getDescription(), createAccountResponse);

           
        })
        .execute(new CreateAccountRequestImpl(createAccountDto));
    }

    getSecurityCounter(): void 
    {
        let securityTokenDto : SecurityTokenDtoImpl = new SecurityTokenDtoImpl();

        this.loginProcessorFactory.getSecurityToken()
            .success((securityTokenResponse : SecurityTokenResponse)=>
            {
              this.getAPIModelHandler().onSuccess(securityTokenResponse.getAPIFeature(), 
              securityTokenResponse.getDescription(), securityTokenResponse.getSecurityCounter());
            })
            .failure((securityTokenResponse : SecurityTokenResponse)=>
            {
                this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(), 
                securityTokenResponse.getDescription(), securityTokenResponse);
            })
            .execute(new SecurityTokenRequestImpl(securityTokenDto));
    }
   
    doLogin(loginDto: LoginDto): void 
    {
    let securityTokenDto: SecurityTokenDtoImpl = new SecurityTokenDtoImpl();
        this.loginProcessorFactory.getSecurityToken()
            .success((securityTokenResponse: SecurityTokenResponse) => {
                this.validatePassword(loginDto, securityTokenResponse.getSecurityCounter());
            })
            .failure((securityTokenResponse: SecurityTokenResponse) => 
            {
                this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(),
                    securityTokenResponse.getDescription(), securityTokenResponse);
            })
            .execute(new SecurityTokenRequestImpl(securityTokenDto));
    }
    
   
    validatePassword(loginDto: LoginDto, securityToken: string) {
        let passwordValidationDto = new PasswordValidationDtoImpl();

        let encryptedPassword = RsaService.getInstance(this.getContext().getProperty())
        .encryptWithNodeRSA(loginDto.getPassword() + securityToken);

        passwordValidationDto.setMsisdn(loginDto.getMsisdn());
        passwordValidationDto.setEncryptedPassword(encryptedPassword);
        passwordValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());
        passwordValidationDto.setSecurityCounter(securityToken);

        this.loginProcessorFactory.validatePassword()
            .success((passwordValidationResponse: PasswordValidationResponse) => 
            {
                this.getAPIModelHandler().onSuccess(passwordValidationResponse.getAPIFeature(),
                loginDto.getMsisdn(), passwordValidationResponse);
            })
            .failure((passwordValidationResponse: PasswordValidationResponse) => {
                this.getAPIModelHandler().onFailure(passwordValidationResponse.getAPIFeature(),
                    passwordValidationResponse.getDescription(), passwordValidationResponse);
            })
            .execute(new PasswordValidationRequestImpl(passwordValidationDto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homeapimodel.tsx